import React, { createContext, useContext } from 'react'

/**
 * Basic collapse context
 *
 * @see https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/context/#basic-example
 */

export type CollapseContextType = [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>
]

export const CollapseContext = createContext<CollapseContextType>(undefined!)

export const useCollapse = () => {
  const context = useContext(CollapseContext)
  if (!context) {
    throw new Error('Missing Collapse Context!')
  }
  return context
}
